import { styled } from '@mui/material/styles';
import Paper from '../../../library/Paper';
import Typography from '../../../library/Typography';

export const StyledPaper = styled(Paper)({
  boxShadow: 'none',
});

export const StyledTitle = styled(Typography)({
  wordBreak: 'break-word',
});
